<template>
  <div class="col mt-3">
    <!-- exit -->

    <div class="row d-flex justify-content-center">
      <button
        type="button"
        class="mt-3 m-3 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="Exit Artefacts"
          position="right"
        >
          <img
            :src="exitImg"
            @click="exitHandler()"
            height="48"
            width="48"
            alt="exit image"
          />
        </ToolTip>
      </button>
    </div>

    <!-- add artefact -->

    <div class="row d-flex justify-content-center">
      <button
        type="button"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        @click="showArtefactPanelHandler()"
      >
        <ToolTip
          text="Add Artefact"
          position="right"
        >
          <i
            class="bi bi-plus"
            style="color: white; font-size: 5em"
          ></i>
        </ToolTip>
      </button>
    </div>

    <!-- scroll right -->
    <div
      v-if="canScrollRight"
      class="row d-flex justify-content-center"
    >
      <button
        type="button"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="Scroll Right"
          position="right"
        >
          <img
            :src="rightImg"
            @click="scrollHandler('right')"
            height="48"
            width="48"
            alt="scroll right image"
          />
        </ToolTip>
      </button>
    </div>

    <!-- scroll left -->
    <div
      v-if="canScrollLeft"
      class="row d-flex justify-content-center"
    >
      <button
        type="button"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="Scroll Left"
          position="right"
        >
          <img
            :src="leftImg"
            @click="scrollHandler('left')"
            height="48"
            width="48"
            alt="scroll left image"
          />
        </ToolTip>
      </button>
    </div>

    <!-- scroll down -->
    <div
      v-if="canScrollDown"
      class="row d-flex justify-content-center"
    >
      <button
        type="button"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="Scroll Down"
          position="right"
        >
          <img
            :src="downImg"
            @click="scrollHandler('down')"
            height="48"
            width="48"
            alt="scroll down image"
          />
        </ToolTip>
      </button>
    </div>

    <!-- scroll up -->
    <div
      v-if="canScrollUp"
      class="row d-flex justify-content-center"
    >
      <button
        type="button"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="Scroll Up"
          position="right"
        >
          <img
            :src="upImg"
            @click="scrollHandler('up')"
            height="48"
            width="48"
            alt="scroll up image"
          />
        </ToolTip>
      </button>
    </div>
  </div>
</template>

<script>
import ToolTip from '../components/ToolTip.vue'
import exitImg from '../assets/images/bbExit100.png'
import rightImg from '../assets/images/bbArrowRight.png'
import leftImg from '../assets/images/bbArrowLeft.png'
import upImg from '../assets/images/bbArrowUp.png'
import downImg from '../assets/images/bbArrowDown.png'
//==========================================================
// scripts
//---------
export default {
  name: 'ArtefactButtonsPanel',
  components: {
    ToolTip,
  },
  props: {
    canScrollLeft: {
      type: Boolean,
      default: false,
    },
    canScrollRight: {
      type: Boolean,
      default: true,
    },
    canScrollDown: {
      type: Boolean,
      default: false,
    },
    canScrollUp: {
      type: Boolean,
      default: false,
    },
  },
  //==========================================================
  // data
  //------
  data() {
    return {
      exitImg,
      rightImg,
      leftImg,
      upImg,
      downImg,
    }
  },
  //==========================================================
  // methods
  //---------
  methods: {
    //--------------
    // exit handler
    //--------------
    exitHandler() {
      this.emitter.emit('exit-artefact-view')
    },
    //-----------------------------
    // show artefact panel handler
    //-----------------------------
    showArtefactPanelHandler() {
      this.emitter.emit('show-artefact-panel')
    },
    scrollHandler(dir) {
      this.$emit('scroll-table', dir)
    },
  },
}
</script>
